import React from 'react'

export default function Radio(props) {
  const {
    label = null,
    size,
    checked,
    defaultChecked,
    onChange,
    ...rest
  } = props

  return (
    <label className={['radio', size && `radio-${size}`]}>
      <input
        {...rest}
        type="radio"
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={event => {
          onChange && onChange(event.target.checked, event)
        }}
      />
      <span>{label}</span>
    </label>
  )
}
